export const GATES = {
  CUSTOMER_PORTAL_GATE: 'CustomerPortal:Config',
  SEO_ADD_CUSTOM_KB_TITLE: 'SEO:AddCustomKBTitle',
  KNOWLEDGE_BASE_V3_1: 'KnowledgeBase:V3.1',
  KNOWLEDGE_BASE_V3_1_OPT_IN: 'KBv3.1BetaOptIn',
  PUBLISH_PRIVATE_CONTENT: 'UserManagement:PublishPrivateContent',
  KNOWLEDGE_BASE_CMP: 'KnowledgeBase:CMP',
  ACCESS_CONTROL_LIBRARY: 'ContentMembership:KbAccessControlLibrary',
  MEMBERSHIPS_ACCESS_GROUPS: 'ContentMembership:AccessGroups',
  SERVICE_HUB_ACCESS_GROUPS: 'ContentMembership:ServiceHubAccessGroups'
};
export const isUngatedForCusomerPortal = gates => gates.includes(GATES.CUSTOMER_PORTAL_GATE);
export const isUngatedForSeoKbTitle = gates => gates.includes(GATES.SEO_ADD_CUSTOM_KB_TITLE);
export const isUngatedForPublishPrivateContentPermissions = gates => gates.includes(GATES.PUBLISH_PRIVATE_CONTENT);
export const isUngatedForKnowledgeBaseV3_1 = gates => gates.includes(GATES.KNOWLEDGE_BASE_V3_1);
export const isUngatedForKnowledgeBaseCMP = gates => gates.includes(GATES.KNOWLEDGE_BASE_CMP);
export const isUngatedForAccessControlLibrary = gates => gates.includes(GATES.ACCESS_CONTROL_LIBRARY);
export const isUngatedForMembershipsAccessGroups = gates => gates.includes(GATES.MEMBERSHIPS_ACCESS_GROUPS);
export const isUngatedForServiceHubAccessGroups = gates => gates.includes(GATES.SERVICE_HUB_ACCESS_GROUPS);